<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import { formatMoney, makeWebsiteRequest, withTax } from '../../Common/tools';
  import { External, M } from '../../external';
  import Loader from '../../Common/Loader.svelte';
  import { enableAddon, LABELS } from './addons';

  export let addon, currency, value, taxRate, widthClass = 'col20';
  let dispatcher = createEventDispatcher();
  let proratedPrice = 0;
  let proratedBasePrice = 0;
  let taxAmount = 0;
  let proratedPriceFormatted = '';
  let fullPrice = 0;
  let fullPriceFormatted = '';
  let renewalDate = '';
  let remainingDays = 0;
  let loading = false;
  let summary = LABELS[addon.type].summary(value);

  let activateAddon = async () => {
    if (loading) {
      return;
    }
    loading = true;
    let result = await enableAddon(addon, value);
    loading = false;
    if (result.ok) {
      External.Tools.showAutohideMessage(1500, 'Addon enabled successfully!');
      dispatcher('confirm', result.data);
    }
  };

  onMount(async () => {
    loading = true;
    let result = await makeWebsiteRequest({
      action: 'calculateAddonPrice',
      data: {
        addon: addon.id,
        value: value
      }
    });
    let prices = result.data;
    fullPrice = withTax(prices.addonPrice, taxRate);
    proratedBasePrice = prices.proratedPrice;
    proratedPrice = withTax(proratedBasePrice, taxRate);
    proratedPriceFormatted = formatMoney(proratedPrice, currency);
    taxAmount = (Math.round(proratedPrice * 100) / 100) - proratedBasePrice;
    fullPriceFormatted = formatMoney(fullPrice, currency);
    let date = External.Tools.ddmmyyStringToDate(prices.renewalDate);
    remainingDays = Math.floor((date - new Date()) / 86400000);
    renewalDate = External.Tools.dateToString(date);
    loading = false;
  });
</script>
<div class="popup-widget-wrapper flex flex-col align-center">
  {#if loading}
    <Loader />
  {:else}
    <div class="f-left t-center {widthClass}">
      <a class="middle-button gray none-soft discard-billing block mb-0" on:click={() => !loading && dispatcher('cancel')}><p>←</p>{M.GO_BACK}</a>
    </div>

    <div class="f-left addon-summary mt-15 {widthClass}">
      <h3 class="total-cost">
        <span>
          <b>{M.SUMMARY}:</b> {summary}
        </span>
      </h3>
      {#if taxAmount > 0.01}
        <h3 class="total-cost">
        <span style="font-size: 14px">
          <b>{M.TOTAL_NO_VAT}</b> <br />
          {M.VAT} ({taxRate}%)
        </span>
        <mark style="font-size: 15px">{formatMoney(proratedBasePrice, currency)}</mark><br />
        <mark style="font-size: 15px">{formatMoney(taxAmount, currency)}</mark>
        </h3>
      {/if}

      <h3 class="total-cost mb-10">
        <span>
          <b>{M.TODAY}</b><br />
          {#if remainingDays > 0}
            ({External.format(M.X_DAYS_RENEWAL, 'x', remainingDays)})
          {/if}
        </span>
        <mark><b>{formatMoney(proratedPrice, currency)}</b></mark>
      </h3>
    </div>

    <div class="price-tables-wrapper table-of-one-full style-1 layout-2 f-left mt-15 {widthClass}">
      <div class="price-table most-popular highlight-table align-center">
        <div class="price-table-inner">
          <div class="price-table-description">
            <ul class="icon-list-wrapper">
            <span class="icon-list-name">
              {@html External.format(M.ADDON_NEXT_CHARGE_INFO, 'prorated', `<b>${proratedPriceFormatted}</b>`, 'price', `<b>${fullPriceFormatted}</b>`, 'date', `<b>${renewalDate}</b>`)}
              <br /><br />
              {M.SUBSCRIPTION_RENEWL_MESSAGE}
              <b class="text-link-hover">{M.PRIVACY_POLICY}</b> {M.AND} <b class="text-link-hover">{M.TERMS_OF_SERVICE}.</b>
            </span>
            </ul>
          </div>
          <div class="price-table-footer mb-5 flex flex-row justify-center">
            <a class="price-table-button" style="max-width: 250px" on:click={activateAddon}>
              {M.CONFIRM}
              <svg class="price-table-arrow" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>
